import type { UserResponse } from "@sidegigllc/api/client";
import { redirect } from "@tanstack/react-router";

export const requireAdmin = (user: UserResponse | undefined): void => {
  if (!user?.is_gigpro_admin) throw redirect({ href: "/" });
};
